'use client'

import * as React from 'react'
import { useHits } from 'react-instantsearch'
import { useLocalStorage } from 'hooks/use-local-storage'

import type { AlgoliaTemplateHit } from '../context/templates-page'

export const LOCAL_STORAGE_KEY = 'algoliaTemplatesSearchResults'
const FOUR_DAYS = 1000 * 60 * 60 * 24 * 4
interface TemplatesLocalStorageData {
  queries: Record<string, number>
  hits: Record<string, string>
}

export function HandleLocalStorage() {
  const { results } = useHits<AlgoliaTemplateHit>()
  const [templatesSearchQueries, setTemplatesSearchQueries] =
    useLocalStorage<TemplatesLocalStorageData>(LOCAL_STORAGE_KEY, { hits: {}, queries: {} })

  React.useEffect(() => {
    if (results?.queryID) {
      const queries = { ...templatesSearchQueries.queries }
      const hits = { ...templatesSearchQueries.hits }
      const resultHits = results.hits.map(hit => hit.objectID)

      //check if any query is older than 4 days
      const queriesToBeRemoved: string[] = []
      const now = Date.now()
      Object.keys(queries).map(key => {
        // oxlint-disable-next-line array-callback-return
        if (now - queries[key] >= FOUR_DAYS) {
          queriesToBeRemoved.push(key)
        }
      })

      //remove the older queries and products from localStorage
      queriesToBeRemoved.forEach(query => {
        // oxlint-disable-next-line typescript/no-dynamic-delete
        delete queries[query]
        Object.keys(hits).forEach(hit => {
          if (hits[hit] === query) {
            // oxlint-disable-next-line typescript/no-dynamic-delete
            delete hits[hit]
          }
        })
      })

      queries[results.queryID] = now
      resultHits.forEach(hit => {
        if (results.queryID) {
          hits[hit] = results.queryID
        }
      })

      setTemplatesSearchQueries({
        queries,
        hits,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results?.queryID])

  return null
}
